import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { DTO_GRAPH__instance } from '../../_graph/DTO_GRAPH__instance';
import { DECORATOR__ui_without_component } from '../_base/_decorators/DECORATOR__ui_without_component';
import { ENUM__field_connectable_type } from '../_base/_methods/ENUM__field_connectable_type';
import { FIELD__tensor_base } from './FIELD__tensor_base';

export class FIELD__tensor_latents extends FIELD__tensor_base {
  /*
   * STATIC FIELDS
   */

  static _class_name_static = ENUM__dto_class_name.GRAPH_FIELD_TENSOR_LATENTS;

  /*
   * FIELDS
   */

  /*
   * PROPERTIES
   */

  field_connectable__value(graph: DTO_GRAPH__instance) {
    return this.meta.field_hash__value_full;
  }

  field_connectable__type() {
    return ENUM__field_connectable_type.TENSOR_LATENTS;
  }

  /*
   * METHODS
   */

  constructor() {
    super();
  }

  @DECORATOR__ui_without_component
  post_init() {
    super.post_init();
  }

  assert_standard_fields(): void {
    super.assert_standard_fields();
  }
}
